import React, { useMemo, useState } from "react"
import { motion } from "framer-motion"
import ollamani_logo from "../../../assets/templates/ollamani/ollamani_logo.png"
import profile from "../../../assets/social_icons/profile.png"
import generateVcard from "../../../functions/generateVcard"
import QrModal from "../../../components/QrModal/QrModal"
import logoColor01 from "../../../assets/templates/ollamani/logos/color/Logos  Unidades de negocio-01.png"
import logoColor03 from "../../../assets/templates/ollamani/logos/color/Logos  Unidades de negocio-03.png"
import logoColor05 from "../../../assets/templates/ollamani/logos/color/Logos  Unidades de negocio-05.png"
import logoColor07 from "../../../assets/templates/ollamani/logos/color/Logos  Unidades de negocio-07.png"
import logoColor09 from "../../../assets/templates/ollamani/logos/color/Logos  Unidades de negocio-09.png"
import logoBlancoNegro02 from "../../../assets/templates/ollamani/logos/blanconegro/Logos  Unidades de negocio-02.png"
import logoBlancoNegro04 from "../../../assets/templates/ollamani/logos/blanconegro/Logos  Unidades de negocio-04.png"
import logoBlancoNegro06 from "../../../assets/templates/ollamani/logos/blanconegro/Logos  Unidades de negocio-06.png"
import logoBlancoNegro08 from "../../../assets/templates/ollamani/logos/blanconegro/Logos  Unidades de negocio-08.png"
import logoBlancoNegro10 from "../../../assets/templates/ollamani/logos/blanconegro/Logos  Unidades de negocio-10.png"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Carousel from "../../../components/Slider/Carousel"
import { handleProfileImageError, resolveProjectPhoto } from "../../../functions/photoHelpers"

const MainCointainer = ({ user, typeOfDevice, projectLogo }) => {
    const showColorLogos = process.env.REACT_APP_OLLAMANI_COLOR_LOGOS === "true"
    const footerLogos = showColorLogos
        ? [logoColor01, logoColor03, logoColor05, logoColor07, logoColor09]
        : [logoBlancoNegro02, logoBlancoNegro04, logoBlancoNegro06, logoBlancoNegro08, logoBlancoNegro10]
    const orderedFooterLogos = [footerLogos[0], footerLogos[1], footerLogos[3], footerLogos[2], footerLogos[4]]
    const resolvedPhoto = resolveProjectPhoto({ photo: user?.photo })

    const { name, lastname, email, phone, linkedin, facebook, instagram, twitter, web, job, video, microsoftteams, animated, projectId
        , excel, powerpoint, pdf, word
    } = user
    const [showQr, setShowQr] = useState(false)
    const url = useMemo(() => {
        const data = generateVcard(user)
        return data
    }, [user])
    const handleQR = () => {
        setShowQr(!showQr)
    }
    const socialStyle = "flex justify-center drop-shadow-lg mt-2"
    const imageStyle = "xl:w-[120px] xl:h-[120px] sm:w-20 sm:h-20 flex content-center p-2"

    const socialLinks = [
        phone,
        email,
        linkedin,
        facebook,
        instagram,
        twitter,
        video,
        microsoftteams
    ].filter(link => link !== undefined && link !== null);

    let infinite = false;

    if (socialLinks.length >= 4) {
        infinite = true;
    }
    if (socialLinks.length <= 3) {
        infinite = false;
    }

    const sliderSettings = {
        dots: false, // Muestra los puntos de navegación
        infinite: infinite, // Permite un desplazamiento infinito
        speed: 500, // Velocidad de transición en milisegundos
        slidesToShow: 3, // Número de elementos mostrados a la vez
        slidesToScroll: 1, // Número de elementos desplazados en cada cambio
        // centerMode: false, // Centra el elemento activo
        centerPadding: "0px",
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3, // Cambia el número de elementos mostrados en dispositivos más pequeños
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 3, // Cambia el número de elementos mostrados en dispositivos aún más pequeños
                },
            },
        ],
    };

    return (
        <main className="flex flex-col justify-evenly md:p-20 sm:p-5 bg-white xl:h-full lg:h-full md:h-screen xs:h-auto">
            <section className="flex flex-col justify-center items-center">
                <motion.img
                    initial={{ opacity: 0, y: -50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: "easeInOut" }}
                    className="mx-auto" src={projectLogo ? projectLogo : ollamani_logo} alt="ollamani" />
            </section>

            <section className="flex md:justify-center md:flex-col sm:flex-col sm:justify-center items-center">
                <QrModal
                    showQr={showQr}
                    setShowQr={setShowQr}
                    url={window.location.href}
                    fullname={`${name} ${lastname}`}
                />
                {/* INFORMACION PERSONAL */}
                <div className="relative w-full">
                    <div className="absolute bg-ollamani-primary border border-ollamani-primary w-full rounded-lg shadow-lg top-1/4" style={{ height: "78%" }}>
                        <motion.div
                            initial={{ opacity: 0, y: -50 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 1, ease: "easeInOut", delay: 1.3 }}>
                        </motion.div>
                    </div>
                    <>
                        <motion.div
                            className="flex flex-col items-center justify-center">
                            <img className="md:w-56 md:mt-0 sm:mt-5 sm:w-40 rounded-full mx-auto drop-shadow-lg border-4 border-ollamani-400"
                                src={resolvedPhoto ? resolvedPhoto : profile} onError={(event) => handleProfileImageError(event, profile)} alt="profile" />
                            {/* <QR></QR> */}
                            <motion.button
                                onClick={handleQR}
                                title="Ver QR"
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.9 }}
                                style={{ filter: "none" }}
                                className="relative flex flex-col items-center justify-center bg-ollamani-400 rounded-full p-2 -top-5">
                                <svg width="20" height="20" fill="none" stroke="#ffff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path fill="#ffff" stroke="none" d="M19.125 15.75h-3a.375.375 0 0 0-.375.375v3c0 .207.168.375.375.375h3a.375.375 0 0 0 .375-.375v-3a.375.375 0 0 0-.375-.375Z"></path>
                                    <path fill="#ffff" stroke="none" d="M15.375 12.75h-2.25a.375.375 0 0 0-.375.375v2.25c0 .207.168.375.375.375h2.25a.375.375 0 0 0 .375-.375v-2.25a.375.375 0 0 0-.375-.375Z"></path>
                                    <path fill="#ffff" stroke="none" d="M22.125 19.5h-2.25a.375.375 0 0 0-.375.375v2.25c0 .207.168.375.375.375h2.25a.375.375 0 0 0 .375-.375v-2.25a.375.375 0 0 0-.375-.375Z"></path>
                                    <path fill="#ffff" stroke="none" d="M22.125 12.75h-1.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h1.5a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375Z"></path>
                                    <path fill="#ffff" stroke="none" d="M14.625 20.25h-1.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h1.5a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375Z"></path>
                                    <path fill="#ffff" stroke="none" d="M19.125 4.5h-3a.375.375 0 0 0-.375.375v3c0 .207.168.375.375.375h3a.375.375 0 0 0 .375-.375v-3a.375.375 0 0 0-.375-.375Z"></path>
                                    <path d="M21 2.25h-6.75a.75.75 0 0 0-.75.75v6.75c0 .414.336.75.75.75H21a.75.75 0 0 0 .75-.75V3a.75.75 0 0 0-.75-.75Z"></path>
                                    <path fill="#ffff" stroke="none" d="M7.875 4.5h-3a.375.375 0 0 0-.375.375v3c0 .207.168.375.375.375h3a.375.375 0 0 0 .375-.375v-3a.375.375 0 0 0-.375-.375Z"></path>
                                    <path d="M9.75 2.25H3a.75.75 0 0 0-.75.75v6.75c0 .414.336.75.75.75h6.75a.75.75 0 0 0 .75-.75V3a.75.75 0 0 0-.75-.75Z"></path>
                                    <path fill="#ffff" stroke="none" d="M7.875 15.75h-3a.375.375 0 0 0-.375.375v3c0 .207.168.375.375.375h3a.375.375 0 0 0 .375-.375v-3a.375.375 0 0 0-.375-.375Z"></path>
                                    <path d="M9.75 13.5H3a.75.75 0 0 0-.75.75V21c0 .414.336.75.75.75h6.75a.75.75 0 0 0 .75-.75v-6.75a.75.75 0 0 0-.75-.75Z"></path>
                                </svg>
                            </motion.button>
                        </motion.div>
                        {/* DATOS */}
                        <div className="leading-tight mb-4 flex flex-col justify-center items-center space-y-3 xs:mt-1 lg:mt-0">
                            <motion.h1
                                initial={{ opacity: 0, y: -50 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, ease: "easeInOut", delay: 0.8 }}
                                className="md:text-4xl sm:text-2xl font-bold text-center text-white font-heading">{name} {lastname}</motion.h1>
                            {
                                job &&
                                <motion.h2
                                    initial={{ opacity: 0, y: -50 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 1, ease: "easeInOut", delay: 1 }}
                                    className="md:text-2xl sm:text-lg text-center text-white uppercase font-body">{job}</motion.h2>

                            }
                            {web &&
                                <motion.a
                                    initial={{ opacity: 0, y: -50 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 1, ease: "easeInOut", delay: 1.3 }}
                                    className="text-xl text-center" href={web.includes("https://") ? `${web}` : `https://${web}/`}>
                                    <span className="text-white">{web.includes("https://") ? web.replace("https://", "") : web}</span>
                                </motion.a>
                            }
                            {
                                <motion.button
                                    initial={{ opacity: 0, y: -50 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 1, ease: "easeInOut", delay: 1.3 }}
                                    className="bg-ollamani-400 text-white font-bold py-2 px-4 rounded-lg text-center"
                                >
                                    <a
                                        href={URL.createObjectURL(url)}
                                        download={`${String(name + lastname)
                                            .normalize("NFD")
                                            .replace(/[\u0300-\u036f]/g, "")}.vcf`}
                                        className="text-white font-body"

                                    >
                                        GUARDAR CONTACTO
                                    </a>
                                </motion.button>
                            }
                        </div>
                    </>
                </div>
            </section>

            <section className="mt-5">
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1, ease: "easeInOut", delay: 1.6 }}
                    className="slider-ollamani  custom-container"
                >
                    <Carousel
                        socialStyle={socialStyle}
                        imageStyle={imageStyle}
                        sliderSettings={sliderSettings}
                        email={email}
                        phone={phone}
                        linkedin={linkedin}
                        microsoftteams={microsoftteams}
                        facebook={facebook}
                        instagram={instagram}
                        twitter={twitter}
                        video={video}
                        animated={animated}
                        typeOfDevice={typeOfDevice}
                        projectId={projectId}
                        excel={excel}
                        powerpoint={powerpoint}
                        pdf={pdf}
                        word={word}
                    />
                </motion.div>
            </section>

            <section className="flex justify-center items-center mt-5">
                <motion.div
                    initial={{ opacity: 0, y: -50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: "easeInOut", delay: 1.9 }}
                    className="mx-auto flex flex-col items-center justify-center gap-4 md:hidden"
                >
                    {orderedFooterLogos.map((logo, index) => (
                        <img
                            key={index}
                            className="h-[6.4rem] w-auto drop-shadow-lg"
                            src={logo}
                            alt={`ollamani-logo-mobile-${index + 1}`}
                        />
                    ))}
                </motion.div>
                <motion.div
                    initial={{ opacity: 0, y: -50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: "easeInOut", delay: 1.9 }}
                    className="mx-auto hidden md:flex md:flex-wrap items-center justify-center gap-4"
                >
                    {orderedFooterLogos.map((logo, index) => (
                        <img
                            key={index}
                            className="h-32 w-auto drop-shadow-lg"
                            src={logo}
                            alt={`ollamani-logo-desktop-${index + 1}`}
                        />
                    ))}
                </motion.div>
            </section>

        </main >
    )
}

export default MainCointainer
